import React from "react";

import { Navigation } from "@/types";

export const NavigationContext = React.createContext<Navigation>([]);
